'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _dec, _dec2, _class2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactLadda = require('react-ladda');

var _reactLadda2 = _interopRequireDefault(_reactLadda);

var _reactRouter = require('react-router');

var _reactDraggableList = require('react-draggable-list');

var _reactDraggableList2 = _interopRequireDefault(_reactDraggableList);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _document = require('redux/modules/document');

var _schoollevels = require('redux/modules/schoollevels');

var _chapter = require('redux/modules/chapter');

var _components = require('../../components');

var _Parser = require('../../helpers/Parser');

var _QuizMCQ = require('./QuizMCQ');

var _QuizMCQ2 = _interopRequireDefault(_QuizMCQ);

var _QuizTrueOrFalse = require('./QuizTrueOrFalse');

var _QuizTrueOrFalse2 = _interopRequireDefault(_QuizTrueOrFalse);

var _QuizFreeAnswer = require('./QuizFreeAnswer');

var _QuizFreeAnswer2 = _interopRequireDefault(_QuizFreeAnswer);

var _QuizSignAndVariationsTable = require('./QuizSignAndVariationsTable');

var _QuizSignAndVariationsTable2 = _interopRequireDefault(_QuizSignAndVariationsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale('fr');

var uniqueID = function uniqueID() {
  return Math.floor(Math.random() * Date.now()).toString();
};

var answerTypes = [{
  key: 'mcq',
  label: 'Choix multiples'
}, {
  key: 'trueOrFalse',
  label: 'Vrai / Faux'
}, {
  key: 'freeAnswer',
  label: 'Réponse libre'
}, {
  key: 'signAndVariationsTable',
  label: 'Tableau de signe/variations'
}];

var answerTypesComponents = {
  mcq: _QuizMCQ2.default,
  trueOrFalse: _QuizTrueOrFalse2.default,
  freeAnswer: _QuizFreeAnswer2.default,
  signAndVariationsTable: _QuizSignAndVariationsTable2.default
};

var LastUpdatedAt = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LastUpdatedAt, _Component);

  function LastUpdatedAt(props) {
    (0, _classCallCheck3.default)(this, LastUpdatedAt);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LastUpdatedAt.__proto__ || (0, _getPrototypeOf2.default)(LastUpdatedAt)).call(this, props));

    _this.state = {
      lastRefresh: new Date()
    };
    return _this;
  }

  (0, _createClass3.default)(LastUpdatedAt, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.timer = setInterval(this.refresh.bind(this), 1000 * 60);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.setState({
        lastRefresh: new Date()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var date = this.props.date;


      if (date) {
        return _react2.default.createElement(
          'span',
          { style: { textTransform: 'initial', color: '#777', fontSize: '14px' } },
          'Enregistr\xE9 ',
          (0, _moment2.default)(date).fromNow(),
          '...'
        );
      }

      return null;
    }
  }]);
  return LastUpdatedAt;
}(_react.Component), _class.propTypes = {
  date: _react.PropTypes.object.isRequired
}, _temp);
var Quiz = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(options) {
    var dispatch = options.store.dispatch,
        _options$params = options.params,
        documentId = _options$params.documentId,
        chapterId = _options$params.chapterId;


    return _promise2.default.all([dispatch((0, _document.load)(documentId)), dispatch((0, _chapter.load)(chapterId)), dispatch((0, _schoollevels.load)())]);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    schoolLevels: state.schoolLevels.data,
    chapter: state.chapter.data,
    document: state.document.data,
    saving: state.document.saving,
    uploadingImage: state.document.uploadingImage,
    uploadedImage: state.document.image,
    config: state.config
  };
}), _dec(_class2 = _dec2(_class2 = (_temp2 = _class3 = function (_Component2) {
  (0, _inherits3.default)(Quiz, _Component2);

  function Quiz(props) {
    (0, _classCallCheck3.default)(this, Quiz);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Quiz.__proto__ || (0, _getPrototypeOf2.default)(Quiz)).call(this, props));

    _this2.getValue = function () {
      var _this2$state = _this2.state,
          document = _this2$state.document,
          selectedQuestionIndex = _this2$state.selectedQuestionIndex,
          selectedQuestionElementPath = _this2$state.selectedQuestionElementPath;

      var selectedQuestion = document.questions[selectedQuestionIndex];
      var value = '';
      if (['content', 'detailedAnswer', 'header'].indexOf(selectedQuestionElementPath) > -1) {
        value = selectedQuestion[selectedQuestionElementPath];
      } else {
        value = selectedQuestion.answer.possibleAnswers[selectedQuestionElementPath].content;
      }

      return value.replace(/<br\s*\/?>/mg, '\n');
    };

    _this2.handleSaveDocument = function () {
      var document = _this2.state.document;

      var isValid = true;

      document.questions.every(function (question, index) {
        if (question.type === 'mcq') {
          var correctAnswer = question.answer.possibleAnswers.find(function (answer) {
            return answer._id === question.answer.correctAnswerId;
          });
          if (!correctAnswer) {
            alert('Erreur : aucune bonne réponse sélectionnée pour la question ' + (index + 1));
            isValid = false;
            return false;
          }
        }

        return true;
      });

      if (isValid) {
        console.log({ document: document });
        _this2.props.dispatch((0, _document.save)(document));
      }
    };

    _this2.handleOpenImageUploadModal = function () {
      _this2.uploadImageInput.click();
    };

    _this2.handleCloseImageUploadModal = function () {
      _this2.setState({
        imageUploadModalVisible: false,
        uploadedImage: undefined
      });
    };

    _this2.handleImageUploadChange = function (event) {
      var data = new FormData();
      data.append('file', event.target.files[0]);
      _this2.setState({
        imageUploadModalVisible: true
      });
      _this2.props.dispatch((0, _document.uploadImage)({ documentId: _this2.state.document._id, data: data }));
    };

    _this2.handleOnQuestionClick = function (index) {
      _this2.setState({
        selectedQuestionIndex: index,
        selectedQuestionElementPath: 'content'
      });
    };

    _this2.handleCreateQuestion = function () {
      var document = _this2.state.document;

      document.questions.push({
        type: 'mcq',
        content: 'Question...',
        detailedAnswer: 'Ici la correction...',
        answer: {
          possibleAnswers: [{
            content: 'Réponse 1',
            _id: uniqueID()
          }, {
            content: 'Réponse 2',
            _id: uniqueID()
          }],
          correctAnswerId: '1'
        }
      });

      _this2.setState({
        selectedQuestionIndex: document.questions.length - 1,
        selectedQuestionElementPath: 'content',
        document: document
      });
    };

    _this2.handleDeleteQuestion = function () {
      if (window.confirm('Etes-vous sûr de vouloir supprimer cette question ?')) {
        var selectedQuestionIndex = _this2.state.selectedQuestionIndex;
        var document = _this2.state.document;

        // 1. Delete active question

        document.questions.splice(selectedQuestionIndex, 1);

        // 2. Update selected index
        selectedQuestionIndex -= 1;
        if (selectedQuestionIndex < 0) selectedQuestionIndex = 0;

        _this2.setState({
          selectedQuestionIndex: selectedQuestionIndex,
          selectedQuestionElementPath: 'content',
          document: document
        });
      }
    };

    _this2.handleTextareaChange = function (event) {
      var _this2$state2 = _this2.state,
          document = _this2$state2.document,
          selectedQuestionIndex = _this2$state2.selectedQuestionIndex,
          selectedQuestionElementPath = _this2$state2.selectedQuestionElementPath;

      var value = event.target.value.replace(/\r?\n/g, '<br />');

      if (['content', 'detailedAnswer', 'header'].indexOf(selectedQuestionElementPath) > -1) {
        document.questions[selectedQuestionIndex][selectedQuestionElementPath] = value;
      } else {
        document.questions[selectedQuestionIndex].answer.possibleAnswers[selectedQuestionElementPath].content = value;
      }

      _this2.setState({
        document: document
      });
    };

    _this2.handleQuestionTypeChange = function (event) {
      var _this2$state3 = _this2.state,
          document = _this2$state3.document,
          selectedQuestionIndex = _this2$state3.selectedQuestionIndex;

      var question = {
        type: event.target.value,
        detailedAnswer: document.questions[selectedQuestionIndex].detailedAnswer,
        content: document.questions[selectedQuestionIndex].content
      };

      switch (question.type) {
        case 'mcq':
          var firstPossibleAnswerId = uniqueID();
          question.answer = {
            possibleAnswers: [{
              content: 'Réponse 1',
              _id: firstPossibleAnswerId
            }, {
              content: 'Réponse 2',
              _id: uniqueID()
            }],
            correctAnswerId: firstPossibleAnswerId
          };
          break;
        case 'trueOrFalse':
          question.answer = true;
          break;
        case 'freeAnswer':
          question.answer = {
            helpMessage: '',
            rows: [{
              prefix: 'f\'(x)',
              answer: 'ax+b'
            }]
          };
          break;
        case 'signAndVariationsTable':
          question.answer = {
            intervals: 2,
            var: {
              header: 'x',
              values: ['?', '?', '?']
            },
            rows: [{
              header: "f'(x)",
              type: 'sign',
              columns: ['+', '-'],
              values: ['0']
            }, {
              header: 'f(x)',
              type: 'var',
              columns: ['+', '-'],
              values: ['?', '?', '?']
            }]
          };
          break;
        default:
          break;
      }

      document.questions[selectedQuestionIndex] = question;

      _this2.setState({
        document: document
      });
    };

    _this2.handleOnAnswerChange = function (answer) {
      var _this2$state4 = _this2.state,
          document = _this2$state4.document,
          selectedQuestionIndex = _this2$state4.selectedQuestionIndex;

      document.questions[selectedQuestionIndex].answer = answer;
      _this2.setState({
        document: document
      });
    };

    _this2.handleDifficultyLevelChange = function (event) {
      var document = _this2.state.document;

      document.difficultyLevel = parseInt(event.target.value, 10);
      _this2.setState({ document: document });
    };

    _this2.handleDurationChange = function (event) {
      var document = _this2.state.document;

      document.duration = parseInt(event.target.value, 10) * 60;
      _this2.setState({ document: document });
    };

    _this2.handleIsEssentialChange = function (event) {
      var document = _this2.state.document;

      document.isEssential = event.target.checked;
      _this2.setState({ document: document });
    };

    _this2.state = {
      document: props.document,
      saving: props.saving,
      uploadingImage: false,
      uploadedImage: undefined,
      imageUploadModalVisible: false,
      selectedQuestionIndex: 0,
      selectedQuestionElementPath: 'content'
    };
    return _this2;
  }

  (0, _createClass3.default)(Quiz, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.document !== 'undefined') {
        var document = nextProps.document;

        this.setState({
          document: document,
          saving: nextProps.saving
        });
      }

      if (this.props.saving && !nextProps.saving) {
        this.setState({ lastUpdatedAt: new Date() });
      }

      if (typeof nextProps.uploadingImage !== 'undefined') {
        this.setState({
          uploadingImage: nextProps.uploadingImage
        });
      }

      if (typeof nextProps.uploadedImage !== 'undefined') {
        navigator.clipboard.writeText('[image:' + nextProps.uploadedImage.filename + ']');
        this.setState({
          uploadedImage: nextProps.uploadedImage
        });
      }
    }
  }, {
    key: 'onListChange',
    value: function onListChange(newList, movedItem, oldIndex, newIndex) {
      console.log({ movedItem: movedItem, oldIndex: oldIndex, newIndex: newIndex });
      var document = this.state.document;

      var question = document.questions[oldIndex];

      document.questions.splice(oldIndex, 1);
      document.questions.splice(newIndex, 0, question);

      for (var pos = 0; pos < newList.length; pos++) {
        newList[pos].index = pos;
      }

      this.setState({
        document: document,
        references: newList,
        selectedQuestionIndex: newIndex
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./Quiz.scss');
      var _state = this.state,
          document = _state.document,
          saving = _state.saving,
          uploadingImage = _state.uploadingImage,
          imageUploadModalVisible = _state.imageUploadModalVisible,
          uploadedImage = _state.uploadedImage,
          selectedQuestionIndex = _state.selectedQuestionIndex,
          selectedQuestionElementPath = _state.selectedQuestionElementPath;
      var _props = this.props,
          schoolLevels = _props.schoolLevels,
          chapter = _props.chapter,
          routeParams = _props.routeParams,
          config = _props.config;

      var schoolLevel = schoolLevels.find(function (level) {
        return level._id === routeParams.schoolLevelId;
      });

      var innerHTML = function innerHTML(html) {
        return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _Parser.textToHtml)(document._id, html, config) } });
      };

      var spanInnerHTML = function spanInnerHTML(tex) {
        return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: (0, _Parser.textToHtml)(document._id, '$' + tex + '$', config) } });
      };

      var references = document.questions.map(function (question, index) {
        return {
          index: index,
          onClick: _this3.handleOnQuestionClick
        };
      });

      var selectedQuestion = document.questions[selectedQuestionIndex];

      var AnswerComponent = answerTypesComponents[selectedQuestion.type];

      return _react2.default.createElement(
        'div',
        { className: styles.document },
        _react2.default.createElement('input', { type: 'file', className: styles.imageUploadInput, ref: function ref(input) {
            return _this3.uploadImageInput = input;
          }, onChange: this.handleImageUploadChange }),
        imageUploadModalVisible && _react2.default.createElement(
          _components.Modal,
          { saving: uploadingImage, className: styles.imageUploadModal, onClose: this.handleCloseImageUploadModal },
          uploadedImage && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              null,
              'Code de l\'image \xE0 copier'
            ),
            _react2.default.createElement('textarea', { disabled: true, value: '[image:' + uploadedImage.filename + ']' })
          ),
          uploadingImage && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Import de l\'image en cours...'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.newDocumentToolbar },
          _react2.default.createElement(
            'span',
            { className: styles.breadcrumb },
            _react2.default.createElement(
              _reactRouter.Link,
              { activeClassName: styles.activeItem, className: styles.breadcrumbLink, to: '/schoollevels/' + schoolLevel._id },
              schoolLevel.name
            ),
            '\xA0\xA0>\xA0\xA0',
            _react2.default.createElement(
              _reactRouter.Link,
              { activeClassName: styles.activeItem, className: styles.breadcrumbLink, to: '/schoollevels/' + schoolLevel._id + '/chapters/' + chapter._id },
              chapter.title
            ),
            '\xA0\xA0>\xA0\xA0',
            document.title
          ),
          this.state.lastUpdatedAt && _react2.default.createElement(LastUpdatedAt, { date: this.state.lastUpdatedAt }),
          _react2.default.createElement(
            'button',
            { className: styles.documentSaveButton, onClick: this.handleOpenImageUploadModal },
            'Importer une image'
          ),
          _react2.default.createElement(
            _reactLadda2.default,
            {
              className: styles.documentSaveButton,
              'data-style': 'slide-down',
              loading: saving,
              onClick: this.handleSaveDocument
            },
            _react2.default.createElement(
              'span',
              null,
              'Enregistrer'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.exercisesList },
          _react2.default.createElement(_reactDraggableList2.default, {
            commonProps: { selectedQuestionIndex: selectedQuestionIndex },
            itemKey: 'index',
            template: _components.MCQQuestionsListItem,
            list: references,
            onMoveEnd: function onMoveEnd(newList, movedItem, oldIndex, newIndex) {
              return _this3.onListChange(newList, movedItem, oldIndex, newIndex);
            },
            container: function container() {
              return document.body;
            }
          }),
          _react2.default.createElement(
            'div',
            { onClick: this.handleCreateQuestion,
              className: styles.exercisesListAddItem },
            _react2.default.createElement(
              'div',
              { className: styles.exercisesListItemTitle },
              '+'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'div',
            { className: styles.difficultyInfos },
            _react2.default.createElement(
              'b',
              null,
              'Difficult\xE9 et dur\xE9e du quiz'
            ),
            _react2.default.createElement(
              'p',
              null,
              '\uD83D\uDCAA ',
              _react2.default.createElement('input', { type: 'number', min: 1, max: 3, onChange: this.handleDifficultyLevelChange, value: document.difficultyLevel }),
              ' / 3'
            ),
            _react2.default.createElement(
              'p',
              null,
              '\u23F1\uFE0F ',
              _react2.default.createElement('input', { type: 'number', min: 1, max: 99, onChange: this.handleDurationChange, value: document.duration / 60 }),
              ' min'
            ),
            _react2.default.createElement(
              'p',
              null,
              '\u2B50 ',
              _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleIsEssentialChange, checked: document.isEssential })
            )
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'button',
            { className: styles.deleteQuestionButton, onClick: this.handleDeleteQuestion },
            'Supprimer la question'
          ),
          selectedQuestion.header && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('span', { style: { display: 'flex', margin: '16px 0', border: '1px solid #e5e5e5', boxSizing: 'border-box' } }),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this3.setState({ selectedQuestionElementPath: 'header' });
                }, className: styles.questionContent + ' ' + (selectedQuestionElementPath === 'header' ? 'active' : '') },
              innerHTML(selectedQuestion.header)
            )
          ),
          _react2.default.createElement('span', { style: { display: 'flex', margin: '16px 0', border: '1px solid #e5e5e5', boxSizing: 'border-box' } }),
          _react2.default.createElement(
            'div',
            { onClick: function onClick() {
                return _this3.setState({ selectedQuestionElementPath: 'content' });
              }, className: styles.questionContent + ' ' + (selectedQuestionElementPath === 'content' ? 'active' : '') },
            innerHTML(selectedQuestion.content)
          ),
          _react2.default.createElement('span', { style: { display: 'flex', margin: '16px 0', border: '1px solid #e5e5e5', boxSizing: 'border-box' } }),
          _react2.default.createElement(
            'select',
            { onChange: this.handleQuestionTypeChange, value: selectedQuestion.type },
            answerTypes.map(function (type, index) {
              return _react2.default.createElement(
                'option',
                { key: index, value: type.key },
                type.label
              );
            })
          ),
          _react2.default.createElement('span', { style: { display: 'flex', margin: '16px 0', border: '1px solid #e5e5e5', boxSizing: 'border-box' } }),
          AnswerComponent && _react2.default.createElement(AnswerComponent, {
            onChange: this.handleOnAnswerChange,
            innerHTML: selectedQuestion.type === 'signAndVariationsTable' ? spanInnerHTML : innerHTML,
            answer: selectedQuestion.answer,
            startEditingMCQAnswer: function startEditingMCQAnswer(answerIndex) {
              return _this3.setState({ selectedQuestionElementPath: answerIndex });
            }
          }),
          _react2.default.createElement('span', { style: { display: 'flex', margin: '16px 0', border: '1px solid #e5e5e5', boxSizing: 'border-box' } }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: styles.detailedAnswerTitle },
              'Correction'
            ),
            _react2.default.createElement(
              'div',
              {
                onClick: function onClick() {
                  return _this3.setState({ selectedQuestionElementPath: 'detailedAnswer' });
                },
                className: styles.detailedAnswerContent + ' ' + (selectedQuestionElementPath === 'detailedAnswer' ? 'active' : '')
              },
              innerHTML(selectedQuestion.detailedAnswer)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.contentTextArea },
            _react2.default.createElement('textarea', {
              value: this.getValue(),
              onChange: this.handleTextareaChange,
              placeholder: 'Vide'
            })
          )
        )
      );
    }
  }]);
  return Quiz;
}(_react.Component), _class3.propTypes = {
  schoolLevels: _react.PropTypes.array.isRequired,
  chapter: _react.PropTypes.object.isRequired,
  document: _react.PropTypes.object.isRequired,
  saving: _react.PropTypes.bool.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  routeParams: _react.PropTypes.object.isRequired,
  config: _react.PropTypes.object.isRequired
}, _temp2)) || _class2) || _class2);
exports.default = Quiz;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Quiz/Quiz.js
// module id = 1178
// module chunks = 0